import { ComponentType } from '@/types';

/**
 * Canonical set of component types that behave as containers
 * (can have children, participate in flex/grid layout as parents).
 *
 * Consolidates 4 previously inconsistent definitions:
 * - CanvasActionApplicator separation bug guard (4 types)
 * - viewer-store.ts isContainerType (4 types)
 * - useTemplateWorkspace.ts isContainerType (3 types)
 * - AIPropertiesChat.tsx isContainerType (2 types)
 *
 * Union of all: 6 distinct container-like types.
 */
export const CONTAINER_LIKE_TYPES = new Set<string>([
  ComponentType.FLEX_CONTAINER,
  ComponentType.CONTAINER,
  ComponentType.CARD,
  ComponentType.DATA_CARD,
  ComponentType.FERMENTATION_TANK_CARD,
  ComponentType.FORM_CONTAINER,
  ComponentType.MODAL,
]);

/**
 * Check if a component type string represents a container-like type.
 * Works with both enum values and raw string literals.
 */
export function isContainerType(type: string | ComponentType): boolean {
  return CONTAINER_LIKE_TYPES.has(type as string);
}
